import { useRequestLotteries } from '~/repositories'

/** Fetches classic-lottery prize list. `params` is a pre-serialised query string. */
export const getPrizesClassic = (params: any) => {
	return useRequestLotteries('get', `/classic_prizes?${params}`)
}

/** Fetches the prize breakdown detail for a classic lottery draw. `params` is a pre-serialised query string. */
export const getPrizeClassicDetail = (params: any) => {
	return useRequestLotteries('get', `/classic_prizes/detail?${params}`)
}

/** Fetches the results list for a classic lottery. `params` is passed as query params object. */
export const getClassicLottery = (params: any) => {
	return useRequestLotteries('get', `/classic_lottery`, { params })
}

/** Fetches the detailed result for a single classic lottery draw. `params` is a pre-serialised query string. */
export const getClassicLotteryDetail = (params: any) => {
	return useRequestLotteries('get', `/classic_lottery/detail?${params}`)
}

export default {
	getPrizesClassic,
	getPrizeClassicDetail,
	getClassicLottery,
	getClassicLotteryDetail,
}
